import { render } from "./ProductsById.vue?vue&type=template&id=6d397a47"
import script from "./ProductsById.vue?vue&type=script&lang=js"
export * from "./ProductsById.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__